<template>
  <SideBarLayoutContent>
    <template #top-bar>
      <h1 class="text-headline-large">{{ $t('todos.title') }}</h1>
    </template>
    <div class="flex flex-col gap-4 pb-10">
      <LoadingWrapper v-if="hasModule(ApplicationModule.COACHING)" :state="loadFeedbackGoalsStatus">
        <BaseHorizontalOverflow
          v-if="feedbackGoals.length > 0"
          show-buttons
          class="relative w-full"
        >
          <ul class="flex w-fit flex-row justify-stretch gap-4">
            <li v-for="feedbackGoal in feedbackGoals" :key="feedbackGoal.id" class="min-w-sm">
              <FeedbackGoal :feedbackGoal="feedbackGoal" class="w-full" />
            </li>
          </ul>
        </BaseHorizontalOverflow>
      </LoadingWrapper>
      <LoadingWrapper :state="loadFeedbackTasksStatus">
        <ul class="flex w-full flex-col gap-0.5">
          <li
            v-for="feedbackTask in feedbackTasks"
            :key="feedbackTask.id"
            class="first:[&>div]:rounded-t-large! last:[&>div]:rounded-b-large! [&>div]:rounded-small! w-full"
          >
            <FeedbackTask :task="feedbackTask" />
          </li>
        </ul>
        <ul v-if="recurringTasks.length > 0" class="flex flex-col gap-1">
          <li v-for="recurringTask in recurringTasks" :key="recurringTask.id">
            <ReccuringFeedbackTask :task="recurringTask" class="w-full" />
          </li>
        </ul>
      </LoadingWrapper>
      <div
        v-if="
          loadFeedbackTasksStatus == ApiRequestStatus.Success &&
          feedbackTasks.length == 0 &&
          recurringTasks.length == 0 &&
          (!hasModule(ApplicationModule.COACHING) ||
            (loadFeedbackGoalsStatus == ApiRequestStatus.Success && feedbackGoals.length == 0))
        "
      >
        <EmptyPage
          :title="$t('todos.empty.title')"
          :description="$t('todos.empty.description')"
          icon="check"
        />
      </div>
    </div>
  </SideBarLayoutContent>
</template>
<script setup lang="ts">
  import BaseHorizontalOverflow from '@/core/components/base/horizontal-overflow/BaseHorizontalOverflow.vue'
  import EmptyPage from '@/core/components/empty-states/EmptyPage.vue'
  import FeedbackGoal from '@/core/components/feedback-task/FeedbackGoal.vue'
  import FeedbackTask from '@/core/components/feedback-task/FeedbackTask.vue'
  import ReccuringFeedbackTask from '@/core/components/feedback-task/ReccuringFeedbackTask.vue'
  import SideBarLayoutContent from '@/core/components/layouts/SideBarLayoutContent.vue'
  import LoadingWrapper from '@/core/components/loading/LoadingWrapper.vue'
  import { useApplicationModule } from '@/core/composables/use-application-module'
  import { ApiRequestStatus } from '@/core/models/api/api-request-status'
  import { ApplicationModule } from '@/core/models/organization'
  import { useFeedbackGoals } from '@/modules/task/composables/useFeedbackGoals'
  import { useFeedbackTasks } from '@/modules/task/composables/useFeedbackTasks'

  const { hasModule } = useApplicationModule()
  const { feedbackTasks, recurringTasks, status: loadFeedbackTasksStatus } = useFeedbackTasks()
  const { feedbackGoals, status: loadFeedbackGoalsStatus } = useFeedbackGoals()
</script>
